import type { PaymentMethod } from '@/shared/api'
import { getLocalStorageValue } from '@/shared/hooks/use-local-storage'

export const emptyPaymentMethod: PaymentMethod = {
    id: 'empty',
    title: 'Пустой способ',
    is_available: true,
    limits: {
        min: 0,
        max: 10_000_000_000,
    },
}

const isStoredPaymentMethod = (value: unknown): value is PaymentMethod => {
    return (
        typeof value === 'object' &&
        value !== null &&
        'id' in value &&
        typeof (value as { id: unknown }).id === 'string'
    )
}

/**
 * Читает способ оплаты из localStorage с проверкой формы.
 * При битых/чужих данных возвращает {@link emptyPaymentMethod}.
 */
export const getStoredPaymentMethod = (): PaymentMethod => {
    const raw = getLocalStorageValue<PaymentMethod>(
        'driver-recharge-selected-method',
        emptyPaymentMethod,
    )

    return isStoredPaymentMethod(raw) ? raw : emptyPaymentMethod
}
